// extracted by mini-css-extract-plugin
module.exports = {"bar":"hamburger-module--bar--QASHY"};